import { render, staticRenderFns } from "./updHsct.vue?vue&type=template&id=9a1bc0d6"
import script from "./updHsct.vue?vue&type=script&lang=js"
export * from "./updHsct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports